/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsUpdateSupplierProduct
 */
export interface ControlcenterMelcoModelsUpdateSupplierProduct {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpdateSupplierProduct
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpdateSupplierProduct
     */
    code?: string | null;
}

export function ControlcenterMelcoModelsUpdateSupplierProductFromJSON(json: any): ControlcenterMelcoModelsUpdateSupplierProduct {
    return ControlcenterMelcoModelsUpdateSupplierProductFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsUpdateSupplierProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsUpdateSupplierProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function ControlcenterMelcoModelsUpdateSupplierProductToJSON(value?: ControlcenterMelcoModelsUpdateSupplierProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'code': value.code,
    };
}


